import React from "react";

const OperatorFilter = () => {
  return (
    <div className="filter-wrapper d-lg-block d-none sticky-sidebar">
      <div className="title_top pb-4">
        <h4>Select Filters</h4>
      </div>

      <div className="title_filter mb-3">
        <h6>Budget Segment</h6>
        <div className="input_check ">
          <div className="d-flex align-items-center">
            <input type="checkbox" className="checkbox_design me-3" />
            <label htmlFor="">Premium</label>
          </div>
          <div className="d-flex align-items-center pt-1">
            <input type="checkbox" className="checkbox_design me-3 " />
            <label htmlFor="">Standard</label>
          </div>
          <div className="d-flex align-items-center pt-1">
            <input type="checkbox" className="checkbox_design me-3 " />
            <label htmlFor="">Economical</label>
          </div>
          <div className="d-flex align-items-center pt-1">
            <input type="checkbox" className="checkbox_design me-3 " />
            <label htmlFor="">Not Included</label>
          </div>
        </div>
      </div>

      <div className="title_filter mb-3">
        <h6>Operator Credibility</h6>
        <div className="input_check ">
          <div className="d-flex align-items-center">
            <input type="checkbox" className="checkbox_design me-3" />
            <label htmlFor="">Offers Other Wildlife Activities</label>
          </div>
          <div className="d-flex align-items-center pt-1">
            <input type="checkbox" className="checkbox_design me-3 " />
            <label htmlFor="">Has Cancellation Policy</label>
          </div>
          <div className="d-flex align-items-center pt-1">
            <input type="checkbox" className="checkbox_design me-3" />
            <label htmlFor="">Wildlife Influencer</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperatorFilter;
